import React from 'react';
import PropTypes from 'prop-types';
import AddCommentForm from './AddCommentForm';
import $ from 'jquery';
import CommentReplies from './CommentReplies';
import ThumbnailUtil from '../../util/ThumbnailUtil';
import AnnotationUtil from '../../queries/annotations/AnnotationUtil';
import _ from 'lodash';
import StoreListener from '../../store/StoreListener';
import { PERMISSIONS } from '../../store/Constants';

@StoreListener(PERMISSIONS)
export default class EditCommentChain extends React.Component {
  static propTypes = {
    onClose: PropTypes.func.isRequired,
    onReply: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    onReplyEdit: PropTypes.func.isRequired,
    onReplyRemove: PropTypes.func.isRequired,
    comment: PropTypes.object.isRequired,
    PERMISSIONS: PropTypes.object
  };

  constructor(props) {
    super(props);
    this.state = {
      comment: props.comment,
      textAreaFocused: false,
      reply: '',
      showAddCommentForm: true,
      creatorFullName: this.getCreatorFromProps()
    };
  }

  componentDidMount() {
    this.listenClickOutside();
  }

  componentWillUnmount() {
    this.stopListeningClicksOutside();
  }

  componentWillMount() {
    this.loadCreatorFullname();
  }

  getCreatorFromProps() {
    return AnnotationUtil.getRootAnnotation(this.props.comment).getCreator();
  }

  loadCreatorFullname() {
    if (!this.getCreatorFromProps()) return;
    ThumbnailUtil.loadUserFullName(this.getCreatorFromProps())
      .then((fullName) => {
        this.setState({ creatorFullName: fullName });
      })
      .catch((errorId) => {
        this.setState({ creatorFullName: 'Anonymous' });
        console.error(errorId);
      });
  }

  listenClickOutside() {
    $('body').on('click.editcommentchain', (event) => {
      //console.log(!$(event.target).parents('.AddCommentForm_Suggestions').length);
      const $elem = $(event.target);
      if ($elem.parents('[name="TextareaSuggestions"]').length) {
        return;
      }

      if (!$elem.parents('#editCommentChainComponent').length) {
        this.props.onClose();
      }
    });
  }

  stopListeningClicksOutside() {
    $('body').off('click.editcommentchain');
  }

  submitReply() {
    const reply = this.state.reply;
    if (_.size(reply) > 0 && reply.trim().length > 0) {
      this.props.onReply(reply, this.state.comment);
      this.setState({
        reply: ''
      });
    } else {
      this.onClose();
    }
  }

  render() {
    const { canWriteComments } = this.props[PERMISSIONS];

    return (
      <div id="editCommentChainComponent">
        <AddCommentForm
          ref="addCommentForm"
          onClose={this.props.onClose}
          onSubmit={this.props.onSubmit}
          comment={this.state.comment}
          global={true}
          edit={true}
          closeOnOutsideClick={false}
        />
        {AnnotationUtil.getReplyCounts(this.state.comment) > 1 ? null : (
          <div style={styles.browseCommentForm}>
            <div id="editChain">
              <CommentReplies
                comment={this.props.comment}
                onEdit={this.props.onReplyEdit}
                onRemove={this.props.onReplyRemove}
              />
            </div>
          </div>
        )}
      </div>
    );
  }

  onClose() {
    return () => this.props.onClose();
  }
}

const styles = {
  scrollView: {
    overflowY: 'auto',
    maxHeight: '224px'
  },
  browseCommentForm: {
    background: 'white',
    boxShadow: '0 15px 30px -10px rgba(0,0,0,0.20)',
    width: '100%',
    padding: '0 15px 15px 15px',
    overflow: 'hidden',
    marginBottom: '10px',
    marginTop: '-10px'
  },
  save: {
    display: 'inline-block',
    float: 'left',
    color: 'white',
    height: '30px',
    lineHeight: '30px',
    marginTop: '10px',
    padding: '0 10px',
    cursor: 'pointer',
    background: '#EB6A5C',
    borderRadius: '2px',
    fontSize: '12px',
    fontWeight: 600,
    letterSpacing: '1px'
  },
  cancel: {
    display: 'inline-block',
    float: 'right',
    height: '30px',
    marginTop: '10px',
    lineHeight: '30px',
    cursor: 'pointer',
    color: '#7A7A7A',
    fontSize: '12px',
    fontWeight: 600,
    letterSpacing: '1px'
  },
  textarea: {
    width: '100%',
    height: '103px',
    border: '1px solid #E7E7E7',
    marginTop: '8px',
    outline: 'none',
    resize: 'none',
    fontSize: '14px'
  },
  avatar: {
    borderRadius: '50%',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    height: '45px',
    width: '45px',
    position: 'absolute',
    top: '10px',
    left: 0
  },
  author: {
    marginTop: '10px',
    color: '#3E3E3E',
    fontSize: '14px',
    lineHeight: '20px'
  },
  text: {
    marginTop: '5px',
    fontSize: '14px',
    lineHeight: '18px',
    color: '#3E3E3E',
    wordWrap: 'break-word'
  },
  lastEdit: {
    display: 'inline-block',
    float: 'left',
    color: '#B5B5B5',
    fontSize: '12px',
    lineHeight: '15px',
    marginTop: '10px',
    marginLeft: '60px'
  }
};
